<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" @close="$emit('update:visible',false)">
      <div class="search_wrap">
        <el-form :inline="true" :model="formdata" class="form-inline">
          <template v-if="type==2">
            <el-form-item>
              <el-cascader style="top: -4px;"
                      placeholder="请选择分类"
                      :options="cateoptions"
                      v-model="formdata.cat_id"
                      :props="defaultprops"
                      :show-all-levels="false"
                      size="small"
              ></el-cascader>
            </el-form-item>
            <el-form-item>
              <el-select clearable v-model="formdata.goods_type" placeholder="请选择商品类型" size="small" style="top: -4px;">
                <el-option
                        v-for="(item,index) in goodstype"
                        :value="item.value"
                        :label="item.label"
                        :key="index"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-input v-model="formdata.name" placeholder="请输入商品名称" size="small">
                <el-button slot="append" icon="el-icon-search" size="small" @click="onSearch"></el-button>
              </el-input>
            </el-form-item>
          </template>
          <template v-if="type==1">
            <el-form-item>
              <el-input v-model="formdata.title" placeholder="请输入表单名称" size="small">
                <el-button slot="append" icon="el-icon-search" size="small" @click="onSearch"></el-button>
              </el-input>
            </el-form-item>           
          </template>
        </el-form>
      </div>   
      <div class="other_wrap">
        <el-button type="primary" :disabled="checkList.length>0?false:true" @click="confirmSelect" size="small">确定选择</el-button>
      </div>  
      <div class="table_wrap">    
        <!-- // 关联商品 -->
        <el-table :data="property" style="width: 100%" v-if="type==2" @selection-change="handleSelectionChange">
          <el-table-column width="55" type="selection"></el-table-column>
          <el-table-column label="商品图片" align="center">
            <template slot-scope="scope">
              <div class="td_img">
                <img :src="scope.row.goods_thumb" alt/>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称" align="center"></el-table-column>
          <el-table-column prop="cat_id" label="所属分类" align="center">
            <template slot-scope="scope">
              <span v-for="(item,index) in scope.row.cat_id" :key="index"><template v-if="index>0">,</template>{{item}}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品类别" align="center">
            <template slot-scope="scope">{{gettypelabel(scope.row.type)}}</template>
          </el-table-column>
          <el-table-column prop="shop_price" width="120" label="商品单价" align="center"></el-table-column>
          <el-table-column prop="goods_number" label="库存" align="center"></el-table-column>
          <el-table-column prop="create_time" width="120" label="创建时间" align="center"></el-table-column>
        </el-table>
        <!-- // 关联表单 -->
        <el-table :data="property" style="width: 100%" v-if="type==1" @selection-change="handleSelectionChange">
          <el-table-column width="55" type="selection"></el-table-column>
          <el-table-column label="背景图" align="center">
            <template slot-scope="scope">
              <div class="formtableimg">
                <img :src="scope.row.back_img" alt />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="title" label="表单名称" align="center"></el-table-column>
          <el-table-column prop="form_enter" label="表单入口" align="center"></el-table-column>
          <el-table-column prop="status" label="有效状态" width="120">
            <template slot-scope="scope">
              <el-switch disabled
                v-model="scope.row.status"
                active-color="#2AA3F8"
                inactive-color="#DDDDDD"
                :active-value="1"
                :inactive-value="0"
              ></el-switch>
            </template>
          </el-table-column>
        </el-table>                
      </div>

    <div class="pag_wrap">
      <el-pagination
        background
        :page-size="page.pagesize"
        :current-page="page.pageindex"
        layout="total, prev, pager, next"
        :total="page.total"
        @current-change="pageIndexChange"
      ></el-pagination>
    </div>        
  </el-dialog>
</template>

<script>
import { 
  getlabelbykey,
  goodtype,
  goodstype 
} from "@/util/util.js";
import api from "@/api.js";
export default {
  name: "momentsEditDialog",
  props: ["page", "type", "visible","property", "formdata", "pageInfo"],  // type 2-选择已上架商品 1-选择表单 
  data() {
    return {
      title: "",
      dialogVisible: false,
      defaultprops: {
        value: "id",
        label: "name",
        children: "child",
        expandTrigger: "hover",
        checkStrictly: "true"
      },      
      cateoptions: [],
      goodstype: goodstype,
      checkList: []
    }
  },
  watch: {
    visible() {
      this.dialogVisible = this.visible;
      if (!this.visible) {
        this.checkList = [];
      }
    },
    type(val) {
      if (val == 2) {
        this.title = "选择已上架商品";
      } else if (val == 1) {
        this.title = "选择表单";
      }; 
    }
  },
  created() {
    if (this.type == 2) {
      this.title = "选择已上架商品";
    } else if (this.type == 1) {
      this.title = "选择表单";
    };  
    this.querycatelist();
  },
  methods: {
    // 查询分类
    querycatelist() {
      let params = {};
      this.axios
          .post(api.goods_goods_cate_list, params)
          .then(response => {
            if (response.data.code == 0) {
              this.cateoptions = this.translatecate(response.data.list || []);
            } else {
            }
          })
          .catch(response => {
          });
    },   
    // 转换分类数据
    translatecate(data) {
      if (data && data.length) {
        data.forEach(item => {
          if (item.child && item.child.length) {
            item.child = this.translatecate(item.child);
          } else {
            item.child = null;
          }
        });
      }
      return data;
    },     
    pageIndexChange(pageindex) {
      this.$emit("loadMoreGoodsOrForm",{pageindex: pageindex, type: this.type, obj: this.formdata});
    },
    onSearch() {
      if (this.type == 2) {
        if ((typeof this.formdata.cat_id == "object") && this.formdata.cat_id.constructor == Array) {
          this.formdata.cat_id = this.formdata.cat_id[this.formdata.cat_id.length - 1];
        }
      }
      this.$emit("loadMoreGoodsOrForm",{pageindex: this.page.pageindex, type: this.type, obj: this.formdata});
    },
    gettypelabel(type) {
      return getlabelbykey(goodtype, type);
    },
    confirmSelect() {
      if (this.checkList.length > 6) {
        this.$message.warning(`最多只能选择6${this.type == 2 ? '件商品' : '个表单'}`);
        return
      }
      let obj = [];
      for (let i = 0; i < this.checkList.length; i++) {
        if (this.type == 2) {
          obj.push({id: this.checkList[i].id, goods_name: this.checkList[i].goods_name});
        } else {
          obj.push({id: this.checkList[i].id, title: this.checkList[i].title});
        }
      }
      this.$emit('updatePageInfo', {type: this.type, obj: obj});
      this.$emit('update:visible', false);
    },
    handleSelectionChange(val) {
      this.checkList = val;
    }
  }
}
</script>

<style type="text/css" scoped>
.formtableimg{display: inline-block;}
</style>